<template lang="pug">
div(v-if="didSearch" v-show="searching")
  v-card.mb-3
    v-card-title.mb-0.title
      v-icon(color="black") search
      | &nbsp; Ihre Suchergebnisse für: {{searchText}}
  v-card.mb-3(v-if="!wiki")
    extra-telefonliste(:query="searchText" :per="5" hide-no-results hide-empty-search :count.sync="telefonlisteCount")

  v-card.mb-3(v-if="projekte.length")
    v-card-title.title
      v-icon(color="black") bubble_chart
      | &nbsp; Suchergebnisse &nbsp;
      router-link(:to="`/projektliste?suche-projekt=${searchText}`") Projekte
    v-data-table(:items="projekte" hide-headers)
      template(slot="items" slot-scope="{ item }")
        td: router-link(:to="`/projektliste?suche-projekt=${item.namePnr}`") {{item.namePnr}}
        td: img(:src="item.logo")

  v-card.mb-3(v-if="register.length")
    v-card-title.title
      v-icon(color="black") description
      | &nbsp; Suchergebnisse für Dokumente im Register
    v-card-text
      template(v-for="doc in register")
        v-icon.icon(small) description
        | &#32; 
        a(target="_blank" :href="doc.docUrl" ) {{ doc.documentName }}
        br 

  v-card.mb-3(v-if="downloads.length")
    v-card-title.title
      v-icon(color="black") description
      | &nbsp; Suchergebnisse Dokumente
    v-card-text
      extra-mein-schreibtisch-prozesse(:categories="[]" :contents="downloads")

  //- extra-download-list(v-if="downloadCategories.length" :extra="{ icon: 'description', name: 'Suchergebnisse Kategorien' }" :categories="downloadCategories")

  template(v-for="extra in downloadExtras")
    extra-download-list(:extra="extra")

  v-card.mb-3(v-if="search.length && !wiki")
    v-card-title.title
      v-icon(color="black") description
      | &nbsp; Suchergebnisse Inhalte
  extra-category-cards(:items="search")

  v-card.mb-3(v-if="!search.length && !downloadExtras.length && !downloads.length && !telefonlisteCount && !projekte.length")
    v-card-title.title
      v-icon(color="black") error
      | &nbsp; Keine Suchergebnisse

  .py-3
  v-divider
  .py-4

</template>

<style lang="stylus" scoped></style>

<script>
import gql from "graphql-tag"
import ExtraCategoryCards from "./extra-category-cards.vue"
import ExtraDownloadList from "./extra-download-list.vue"
import ExtraMeinSchreibtischProzesse from "./extra-mein-schreibtisch-prozesse"
import ExtraTelefonliste from "./extra-telefonliste.vue"
import { debounce, escapeRegExp } from "lodash"

export default {
  props: ["extra"],
  components: {
    ExtraCategoryCards,
    ExtraDownloadList,
    ExtraMeinSchreibtischProzesse,
    ExtraTelefonliste
  },
  data() {
    return {
      telefonlisteCount: 0,
      didSearch: false,
      searchText: "",
      searchData: [],
      downloadsData: [],
      downloadExtraData: [],
      downloadCategoryData: [],
      projekteData: [],
      registerData: []
    }
  },
  fetchPolocy: "no-cache",
  apollo: {
    searchData: {
      query() {
        if (this.wiki) {
          return gql`query ($q: String!, $kategorien: [ID!]) {
            searchData: search(q: $q, kategorien: $kategorien, children: true) {
              id
              slug
              title
              preamble
              inSlider
              image
              categoryId
              kategorie {
                id
                slug
                name
              }
            }
          }`
        } else {
          return gql`query ($q: String!, $qProjekte: String, $kategorien: [ID!]) {
            searchData: search(q: $q, kategorien: $kategorien) {
              id
              slug
              title
              preamble
              inSlider
              image
              kategorie {
                id
                slug
                name
              }
            }
            searchDownload(q: $q) {
              id
              title
              content
              media {
                id
                title
                image
                url
              }
              links {
                id
                name
                url
              }
            }
            searchDownloadExtra(q: $q) {
              id
              name
              content
            }
            projekte(q: $qProjekte) {
              id
              namePnr
              logo(size: "100x50")
            }
            searchRegisterDocs(q: $q) {
            id
            documentName
            docUrl
          }
          }`
        }
      },
      variables() {
        const q = this.searchText
        const qProjekte = {
          m: "or",
          name_contains: q,
          it_standort_strasse_contains: q
        }
        if (/^[Pp]?\d+$/.test(q)) {
          qProjekte.personal_schluessel_eq = q.replace(/[Pp]/, "") || null
        }
        return {
          q: q,
          qProjekte: JSON.stringify(qProjekte),
          kategorien:
            this.extra &&
            this.extra.options &&
            this.extra.options.show_categories
        }
      },
      skip() {
        return !this.searchText
      },
      update(result) {
        if (result.searchData) {
          const reg = new RegExp(
            escapeRegExp(this.searchText || "").replace(/\s+/, ".*")
          )
          this.downloadsData = (result.searchDownload || []).map(d => ({
            title: d.title,
            content: d.content,
            media: d.media,
            links: d.links,
            open: false
          }))
          this.downloadCategoryData = result.searchDownloadCategory
          this.downloadExtraData = result.searchDownloadExtra
          this.projekteData = result.projekte
          this.registerData = result.searchRegisterDocs
          return result.searchData
        } else {
          return []
        }
      }
    }
  },
  watch: {
    "$route.query.suche": {
      immediate: true,
      handler(search) {
        if (search && !this.didSearch) {
          this.didSearch = true
        }
        this.updateSearch(search)
      }
    }
  },
  computed: {
    wiki() {
      return !!(this.extra && this.extra.options && this.extra.options.wiki)
    },
    searching() {
      const searching = !!this.$route.query.suche
      return searching
    },
    search() {
      if (this.searchText) {
        return this.searchData
      } else {
        return []
      }
    },
    downloads() {
      if (this.searchText) {
        return this.downloadsData || []
      } else {
        return []
      }
    },
    downloadCategories() {
      if (this.searchText) {
        return this.downloadCategoryData || []
      } else {
        return []
      }
    },
    downloadExtras() {
      if (this.searchText) {
        return this.downloadExtraData || []
      } else {
        return []
      }
    },
    projekte() {
      if (this.searchText) {
        return this.projekteData || []
      } else {
        return []
      }
    },
    register() {
      if (this.searchText) {
        return this.registerData || []
      } else {
        return []
      }
    }
  },
  methods: {
    updateSearch: debounce(function(search) {
      if (this.searchText !== search) {
        this.searchText = search
      }
    }, 500)
  }
}
</script>
